import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constants/queryKey';
import { searchService } from 'shared/src/api';

export const usePopularKeywords = (ageValue: number) => {
  return useSuspenseQuery({
    queryKey: queryKey.popularKeywords(ageValue),
    queryFn: () => searchService.getPopularKeywords(ageValue),
  });
};
